// extracted by mini-css-extract-plugin
export var brand = "_9u-9";
export var compact = "_9u-6";
export var extraSmall = "_9u-7";
export var icon = "_9u-0";
export var large = "_9u-4";
export var light = "_9u-1";
export var medium = "_9u-5";
export var outline = "_9u-b";
export var primaryDark = "_9u-a";
export var primaryLight = "_9u-8";
export var primaryModern = "_9u-c";
export var success = "_9u-2";
export var successSolid = "_9u-3";